import { useCallback, useEffect, useState, useRef } from "react";

import { useAuth } from "../../../context/auth";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { RadioButton } from 'primereact/radiobutton';
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import { AddPermissaoVerOcorrencia } from "../../../components/Dialogs/AddPermissaoVerOcorrencias";

import api from "../../../services/api";

export function Ocorrencias() {
    const initialForm = {
        data: new Date(),
        descricao: "",
        data_prevista: null,
        destinatario_id: null
    };
    const [data, setData] = useState([]);
    const [form, setForm] =  useState(initialForm);

    const [initialDate, setInitialDate] = useState();
    const [finalDate, setFinalDate] = useState();
    const [showPermissaoDialog, setShowPermissaoDialog] = useState(false);

    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const [inputType, setInputType] = useState('1');

    const toast = useRef();

    const auth = useAuth();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });
    const showPermissaoSuccess = () => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: 'Permissão atualizada com sucesso.' });

    function changeVisibility() {
        setIsVisible(!isVisible);
    }

    function handleDelete(rowData) {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir",
            message: () => <div>
                <p>Você tem certeza que deseja excluir essa ocorrência?</p>
            </div>,
            accept: () => {
                setIsLoading(true);
                api.delete(`ocorrencias/${rowData.id}/delete`).then((response) => {
                    setIsLoading(false);
                    showSuccess(response);
                    setData(prevData => prevData.filter(item => item.id !== rowData.id));
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const formatDate = (date) => {
        if (date !== null && date && date.getDate()) {
            let day = String(date.getDate()).padStart(2, 0);
            let month = String(date.getMonth() + 1).padStart(2, 0);
            let year = String(date.getFullYear());

            return `${year}-${month}-${day}`
        }
        return null;
    }

    function handleSubmit() {
        if (isEditing && editingId !== null) {
            setIsVisible(false);
            setIsLoading(true);
            api.put(`ocorrencias/${editingId}/update`, {
                "descricao": form.descricao,
                "data_prevista": formatDate(form.data_prevista),
                "destinatario_id": form.destinatario_id
            }).then((response) => {
                setIsLoading(false);
                getData();
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsVisible(false);
            setIsLoading(true);
            api.post("ocorrencias", {
                "data": formatDate(form.data),
                "descricao": form.descricao,
                "data_prevista": formatDate(form.data_prevista),
                "destinatario_id": form.destinatario_id
            }).then((response) => {
                setIsLoading(false);
                getData();
                setForm(initialForm);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    function handleSearch() {
        let data_inicial = formatDate(initialDate);
        let data_final = formatDate(finalDate);

        if (data_inicial === null || data_final === null) {
            toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Selecione as datas corretamente!' })
            return;
        }

        setIsLoading(true);
        api.get("ocorrencias", {
            params: {
                data_inicial: data_inicial,
                data_final: data_final
            }
        }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                setData(response.data);
            }
        }).catch((error) => {
            setIsLoading(false);
        });
    }

    function handleEdit(rowData) {
        setEditingId(rowData.id)
        setIsEditing(true);
        setIsVisible(true);
        setForm({
            descricao: rowData.descricao,
            data_prevista: rowData.data_prevista
                ? new Date(`${rowData.data_prevista}T00:00:00-03:00`)
                : null,
            destinatario_id: rowData.destinatario_id ?? null
        });
    }

    function handleVerify(id) {
        setIsLoading(true);
        api.get(`ocorrencias/${id}/visualize`).then((response) => {
            if (response.status === 201) {
                if (initialDate && finalDate) {
                    handleSearch();
                } else {
                    getData();
                }
                setIsLoading(false);
                showSuccess(response);
            }
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    const getData = useCallback(() => {
        let data_atual = new Date();

        let dataf = data_atual.getFullYear() + '-' + String(data_atual.getMonth() + 1).padStart(2, '0') + '-' + String(data_atual.getDate()).padStart(2, '0');

        setIsLoading(false);
        api.get("ocorrencias", {
            params: {
                data_inicial: dataf,
                data_final: dataf
            }
        }).then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        getData();

        let _inputType = localStorage.getItem('inputType');
        if (!_inputType) {
            setInputType('1');
        } else {
            if (_inputType === '1' || _inputType === '2') {
                setInputType(_inputType);
            }
        }
    }, [getData]);

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />

            <Dialog
                header={isEditing ? "Editar" : "Nova Ocorrência"}
                onHide={() => {
                    setEditingId(null);
                    setIsEditing(false);
                    setForm({
                        data: new Date(),
                        descricao: "",
                        data_prevista: null,
                        destinatario_id: null
                    });
                    setIsVisible(false);
                }}
                style={{ minWidth: "50%" }}
                visible={isVisible}
            >
                <div className="p-fluid editor">
                    <Button
                        className="p-md-1 p-mt-2 p-mb-2"
                        icon="pi pi-refresh"
                        label="Alterar Caixa de Texto"
                        onClick={() => {
                            setInputType(inputType === '1' ? '2' : '1');
                            localStorage.setItem('inputType', inputType === '1' ? '2' : '1');
                            setForm({ ...form, descricao: '' });
                        }}
                        title="Clique para alterar o tipo (Ao clicar, o texto que está inserido na caixa será perdido)"
                    />
                    <hr />
                    {!isEditing && (
                        <div className="p-field">
                            <label htmlFor="data">Data: </label>
                            <Calendar
                                className="p-m-1"
                                dateFormat="dd/mm/yy"
                                onChange={e => setForm({ ...form, data: e.value })}
                                mask="99/99/9999"
                                value={form.data}
                            />
                        </div>
                    )}
                    <div className="p-field">
                        <label htmlFor="data_prevista">Data Prevista: </label>
                        <Calendar
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            onChange={e => setForm({ ...form, data_prevista: e.value })}
                            mask="99/99/9999"
                            value={form.data_prevista}
                        />
                    </div>
                    <div className="p-field">
                        <label>Destinatário</label>
                        <div className="p-formgrid p-grid">
                            <div className="p-field-radiobutton p-col-12 p-md-4">
                                <RadioButton
                                    inputId="destinatario_null"
                                    name="destinatario"
                                    value={null}
                                    onChange={() =>
                                        setForm(prev => ({ ...prev, destinatario_id: null }))
                                    }
                                    checked={form.destinatario_id === null}
                                />
                                <label htmlFor="destinatario_null">Todos</label>
                            </div>
                                <div className="p-field-radiobutton p-col-12 p-md-4">
                                    <RadioButton
                                        inputId="destinatario"
                                        name="destinatario"
                                        value={4}
                                        onChange={(e) => setForm(prev => ({...prev, destinatario_id: e.value}))}
                                        checked={form.destinatario_id === 4}
                                    />
                                    <label htmlFor="destinatario">Supervisão</label>
                                </div>  
                            </div>
                        </div>
                    <div className="p-field">
                        <label htmlFor="descricao">Descrição: </label>
                        {inputType === '1' ? (
                            <Editor
                                className="p-m-1"
                                onTextChange={e => setForm({ ...form, descricao: e.htmlValue, descricaoTexto: e.textValue })}
                                placeholder="Descrição das ocorrências..."
                                style={{ height: '320px' }}
                                value={form.descricao}
                            />
                        ) : (
                            <InputTextarea
                                className="p-m-1"
                                onChange={e => setForm({ ...form, descricao: e.target.value })}
                                placeholder="Descrição das ocorrências..."
                                style={{ height: '320px' }}
                                value={form.descricao}
                            />
                        )}

                    </div>
                    <div className="p-d-flex p-flex-row">
                        <Button className="p-button-secondary p-mr-6" label="Cancelar" onClick={changeVisibility} type="button"/>
                        <Button className="p-button-success p-ml-6" label="Salvar" onClick={handleSubmit} type="button"/>
                    </div>
                </div>
            </Dialog>

            <Card
                className="pm-1"
                title={
                    <div className="p-d-flex p-ai-center p-jc-between">
                        <span>Ocorrências</span>
                        {auth.user.id === 4 && (
                            <Button
                                icon="pi pi-lock"
                                className="p-button-rounded p-button-lg p-button-warning"
                                onClick={() => setShowPermissaoDialog(true)}
                            />
                        )}
                    </div>
                }
                subTitle="Ocorrências do Mês - Caso queira pesquisar outros meses, use os campos de data abaixo:"
            >
                <nav className="p-d-flex p-flex-row p-grid" >
                    <Calendar
                        className="p-m-1 p-col-12 p-md-3"
                        dateFormat="dd/mm/yy"
                        onChange={e => setInitialDate(e.value)}
                        mask="99/99/9999"
                        placeholder="Escolha a Data Inicial..."
                        value={initialDate}
                    />
                    <Calendar
                        className="p-m-1 p-col-12 p-md-3"
                        dateFormat="dd/mm/yy"
                        onChange={e => setFinalDate(e.value)}
                        mask="99/99/9999"
                        placeholder="Escolha a Data Final..."
                        value={finalDate}
                    />
                    <Button
                        className="p-button-rounded p-button-success p-md-1 p-mt-2"
                        icon="pi pi-search"
                        onClick={handleSearch}
                        title="Clique para pesquisar ocorrências após inserir as datas corretamente"
                    />
                    <div className="p-ml-auto">
                        {auth.user.id === 4 && (
                        <Button
                            className="p-button-rounded p-md-1 p-mt-1"
                            icon="pi pi-plus"
                            onClick={changeVisibility}
                            title="Clique para adicionar uma nova ocorrência"
                        />
                        )}
                    </div>

                </nav>
                    <section>
                        <DataTable
                            className="p-m-1"
                            emptyMessage="Nenhum registro encontrado."
                            responsiveLayout="stack"
                            scrollHeight="800px"
                            value={data}
                        >
                            <Column header="Responsável" field="nome" />
                            <Column header="Data" field="dataf" />
                            <Column header="Data Prevista" field="datap" body={(rowData) =>
                                rowData.datap
                                    ? rowData.datap
                                    : <span style={{ color: '#999' }}>--</span>
                            } />
                            <Column header="Criação" field="datac" />
                            <Column header="Visualizações" field="visualizacoes" bodyStyle={{ whiteSpace: "pre-wrap" }} body={(rowData) => {
                                let string = rowData.visualizacoes.replaceAll("-", "\n");
                                return string;
                            }} />
                            <Column header="Ocorrências" field="descricao" style={{ width: "50%" }} body={(rowData) => (
                                <div className="p-m-2" dangerouslySetInnerHTML={{ __html: rowData.descricao }} />
                            )} />
                            <Column header="Destinatário" field="destinatario" body={(rowData) => {
                                if (rowData.destinatario) { return 'Supervisão'; }
                                return <span>Todos</span>;
                            }} />
                            <Column header="Ações" body={(rowData) => (
                                <div>
                                    {auth.user.id === 4 && (
                                        <>
                                            <Button
                                                className="p-m-1 p-button-rounded p-button-primary"
                                                icon="pi pi-pencil"
                                                onClick={() => handleEdit(rowData)}
                                                title="Clique para editar a ocorrência"
                                            />
                                            <Button
                                                className="p-m-1 p-button-rounded p-button-danger"
                                                icon="pi pi-trash"
                                                onClick={() => handleDelete(rowData)}
                                                title="Clique para excluir a ocorrência"
                                            />
                                        </>
                                    )}
                                    <Button
                                        className="p-m-1 p-button-rounded p-button-success"
                                        disabled={rowData.verificado}
                                        icon="pi pi-check"
                                        onClick={() => handleVerify(rowData.id)}
                                        title="Clique para verificar a ocorrência"
                                    />
                                </div>
                            )} />
                        </DataTable>
                    </section>
            </Card>
            <AddPermissaoVerOcorrencia
                visible={showPermissaoDialog}
                onHide={() => setShowPermissaoDialog(false)}
                onSuccess={showPermissaoSuccess}
            />
        </div>


    )
}